import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertToYesNo',
})
export class ConvertToYesNoPipe implements PipeTransform {
  transform(value: boolean) {
    return value ? 'Yes' : 'No';
  }
}
